<template>
    <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl"
        role="document"
    >
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <modal-close />
                <div class="modal-title">
                    <h2 class="h3 pt-1 mb-0">Edycja użytkownika sklepowego</h2>
                </div>
            </div>
            <div class="modal-body p-4 border-top">
                <div class="c-service__basic row">
                    <div class="col-lg-6 col-12 pb-sm-0 pb-4">
                        <div>
                            <h2 class="h6 mb-4">Login</h2>
                            <the-input
                                :readonly="true"
                                id="mp-login"
                                class="mb-4"
                                :type="'text'"
                                :label="'Login'"
                                :name="'mp-login'"
                                :text="login"
                            />
                        </div>
                        <div>
                            <h2 class="h6 mb-4">Zmiana hasła</h2>
                            <div style="margin-top: -12px">
                                Hasło powinno zawierać:
                                <ul>
                                    <li>przynajmniej 6 znaków</li>
                                    <li>co najmniej 1 małą literę</li>
                                    <li>co najmniej 1 wielką literę</li>
                                    <li>co najmniej 1 cyfrę</li>
                                    <li>
                                        co najmniej 1 znak specjalny (@$!%*?&)
                                    </li>
                                </ul>
                            </div>
                            <the-input
                                class="mb-4"
                                id="mp-newPassword"
                                :type="'password'"
                                :invalid="invalidNew"
                                :invalidFeedback="'Hasło nie spełnia wymagań.'"
                                label="Nowe hasło"
                                name="'mp-newPassword'"
                                @input="passwords.newPassword = $event"
                                :text="passwords.newPassword"
                            />
                            <the-input
                                class="mb-0"
                                id="mp-repeatNewPassword"
                                :type="'password'"
                                :invalid="invalidRepeat"
                                :invalidFeedback="
                                    'Podane hasła nie są identyczne.'
                                "
                                label="Powtórz hasło"
                                name="'mp-repeatNewPassword'"
                                @input="passwords.repeatNewPassword = $event"
                                :text="passwords.repeatNewPassword"
                            />
                        </div>
                    </div>
                    <div class="col-lg-6 col-12 pb-sm-0 pb-4">
                        <div>
                            <h2 class="h6 mb-4">Nazwa</h2>
                            <the-input
                                id="mp-userAlias"
                                style="max-width: 400px"
                                class="mb-4"
                                :type="'text'"
                                :label="'Nazwa'"
                                :name="'mp-userAlias'"
                                @input="userAlias = $event"
                                :text="userAlias"
                            />
                        </div>
                        <div class="mb-4">
                            <store-user-permissions
                                :permissions="permissions"
                                title="Uprawnienia"
                                is-editable
                                @onChange="permissions = $event"
                            />
                        </div>
                        <div>
                            <h2 class="h6 mb-4">Sklepy</h2>
                            <div
                                class="mb-4"
                                :class="{
                                    'text-danger': invalidStorePermissions
                                }"
                            >
                                <a-icon
                                    icon="InvalidMark"
                                    v-if="invalidStorePermissions"
                                    style="vertical-align: sub; width: 18px; height: 18px"
                                />
                                Wybierz sklepy do których użytkownik będzie miał
                                dostęp:
                            </div>
                            <page-preloader
                                small
                                minHeight="30px"
                                v-if="this.storePermissionsStatus === 'loading'"
                            >
                            </page-preloader>
                            <ui-checkbox-input
                                v-else
                                v-for="(store, id) in storePermissionsData"
                                class="text-sm"
                                :class="{ 'text-danger': store.status === 'N' }"
                                :key="id"
                                :name="'store-' + id"
                                @change="e => onSelectedStoreChange(store, e)"
                                :value="
                                    storeIds.some(r =>
                                        storeIds.includes(store.value)
                                    )
                                "
                                :label="store.label"
                                :tooltipLabel="
                                    `${
                                        store.status === 'N'
                                            ? 'Sklep jest nieaktywny'
                                            : ''
                                    }`
                                "
                            />
                        </div>
                    </div>
                    <div
                        class="modal-footer col-12 d-block d-sm-flex justify-content-sm-between mt-4"
                    >
                        <store-users-delete-btn
                            :login="login"
                            :id="locationUserId"
                            :editMode="true"
                        />
                        <div class="row">
                            <div class="col-6 pl-0">
                                <button
                                    type="button"
                                    class="btn btn-outline w-100"
                                    data-dismiss="modal"
                                    @click="closeModal"
                                >
                                    Anuluj
                                </button>
                            </div>
                            <div class="col-6 pr-0">
                                <button
                                    type="button"
                                    class="btn btn-secondary w-100"
                                    data-dismiss="modal"
                                    @click="editUser"
                                >
                                    Zapisz
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StoreUsersDeleteBtn from '../settings/storeUsersManagement/StoreUsersDeleteBtn'

export default {
    components: { StoreUsersDeleteBtn },
    data() {
        return {
            passwords: {
                newPassword: '',
                repeatNewPassword: ''
            },
            invalidRepeat: false,
            invalidNew: false,
            invalidStorePermissions: false,
            previousStoreIds: [],
            storeIds: [],
            storePermissionsData: [],
            userAlias: null,
            permissions: []
        }
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.userAlias = this.userAliasData
            this.permissions = this.$store.getters.modalState.args.permissions
            this.$store
                .dispatch('storePermissionsFetch', this.locationUserId)
                .then(res => {
                    if (res) {
                        this.storePermissionsData = res.data.data
                            .filter(el => {
                                return (
                                    el.hasPermission ||
                                    (!el.hasPermission && el.status === 'Y')
                                )
                            })
                            .map(el => {
                                const option = {
                                    value: el.shopId,
                                    label: el.shopName + ', ' + el.shopAddress,
                                    status: el.status
                                }
                                if (el.hasPermission) {
                                    this.previousStoreIds.push(option.value)
                                    if (!this.storeIds.includes(el.shopId)) {
                                        this.onSelectedStoreChange(option, true)
                                    }
                                }
                                return option
                            })
                    }
                })
        },
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        },
        validateNewPassword(value) {
            const validationResult =
                value.length === 0 ||
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@$%&?*]).{6,}$/.test(
                    value
                )
            this.invalidNew = !validationResult
            return validationResult
        },
        validateRepeatPassword(value) {
            const validationResult = this.passwords.newPassword === value
            this.invalidRepeat = !validationResult
            return validationResult
        },
        validateStorePermissions(value) {
            const validationResult = value.length > 0
            this.invalidStorePermissions = !validationResult
            return validationResult
        },
        editUser() {
            this.validateNewPassword(this.passwords.newPassword)
            this.validateRepeatPassword(this.passwords.repeatNewPassword)
            this.validateStorePermissions(this.storeIds)
            if (
                !this.invalidNew &&
                !this.invalidRepeat &&
                !this.invalidStorePermissions
            ) {
                const isStoreChanged = !(
                    this.storeIds.length === this.previousStoreIds.length &&
                    this.storeIds.every(v => this.previousStoreIds.includes(v))
                )
                this.$store.dispatch('editStoreUser', {
                    location_user_id: this.$store.getters.modalState.args.id,
                    password: this.passwords.newPassword.length
                        ? this.passwords.newPassword
                        : null,
                    location_ids: this.storeIds,
                    user_alias: this.userAlias,
                    permissions: this.permissions.length
                        ? this.permissions
                        : ['promotions.read'],
                    isStoreChanged: isStoreChanged
                })
            }
        },
        onSelectedStoreChange(option, checked) {
            let tmp = this.storeIds
            if (checked) {
                tmp.push(option.value)
            } else {
                tmp = tmp.filter(e => e !== option.value)
            }
            this.storeIds = tmp
        }
    },
    computed: {
        login() {
            return this.$store.getters.modalState.args.login
        },
        locationUserId() {
            return this.$store.getters.modalState.args.id
        },
        userAliasData() {
            return this.$store.getters.modalState.args.userAlias
        },
        storePermissionsStatus() {
            return this.$store.getters.getStorePermissionsStatus
        }
    }
}
</script>
